var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRsHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8343_103703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 0.917145C16.3742 0.93466 15.2727 1.249 14.307 1.82842C13.3413 2.40783 12.5456 3.23181 12.0002 4.21714C11.4548 3.23181 10.6591 2.40783 9.69344 1.82842C8.72774 1.249 7.62625 0.93466 6.5002 0.917145C4.70514 0.995135 3.01391 1.7804 1.79599 3.10138C0.578062 4.42236 -0.0675481 6.17167 0.000202431 7.96714C0.000202431 14.7421 10.9562 22.5671 11.4222 22.8991L12.0002 23.3081L12.5782 22.8991C13.0442 22.5691 24.0002 14.7421 24.0002 7.96714C24.068 6.17167 23.4223 4.42236 22.2044 3.10138C20.9865 1.7804 19.2953 0.995135 17.5002 0.917145ZM12.0002 20.8461C8.7472 18.4161 2.0002 12.4461 2.0002 7.96714C1.93184 6.70186 2.36657 5.46087 3.20957 4.51484C4.05256 3.56881 5.23544 2.9945 6.5002 2.91714C7.76497 2.9945 8.94784 3.56881 9.79084 4.51484C10.6338 5.46087 11.0686 6.70186 11.0002 7.96714H13.0002C12.9318 6.70186 13.3666 5.46087 14.2096 4.51484C15.0526 3.56881 16.2354 2.9945 17.5002 2.91714C18.765 2.9945 19.9478 3.56881 20.7908 4.51484C21.6338 5.46087 22.0686 6.70186 22.0002 7.96714C22.0002 12.4481 15.2532 18.4161 12.0002 20.8461Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8343_103703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsHeart);
export default __webpack_public_path__ + "static/media/fi-rs-heart.5d0090b2db119f10022b1880169c6f00.svg";
export { ForwardRef as ReactComponent };